import { useAddJobListPageToDomainMutation } from "@/redux/reducer/customers.api";
import { ModalForm, TalentechFormFieldTypes } from "@talentech/components";
import React from "react";
import { toast } from "react-toastify";

interface ModalProps {
  showModal: boolean;
  toggleModal: () => void;
  onAssigned?: () => void;
  options: any[];

  domain_id: string;
  tenant_id: string;
}

interface ModalFormValues {
  career_site: {
    site_id: {
      value: string;
      label: string;
    };
  };
}

const AssignCareerSite: React.FC<ModalProps> = ({
  options,
  tenant_id,
  domain_id,
  onAssigned,
  ...props
}) => {
  const [addCareerSite] = useAddJobListPageToDomainMutation();
  const handleSubmit = (data: ModalFormValues) => {
    const promise = addCareerSite({
      joblist_page_id: data.career_site.site_id.value,
      domain_id,
      tenant_id,
    });

    toast
      .promise(promise.unwrap(), {
        pending: "Assigning career site...",
        success: "Career site assigned",
        error: "Failed to assign career site",
      })
      .then(() => {
        props.toggleModal();
        onAssigned?.();
      });
  };

  return (
    <ModalForm
      modal={{
        title: "Assign Career Site",
        ...props,
      }}
      form={{
        formFields: {
          fields: [
            {
              field: "site_id",
              label: "Career site",
              type: TalentechFormFieldTypes.SELECT,
              size: {
                xs: 12,
              },
              options: {
                options,
              },
            },
          ],
          id: "career_site",
          section: "",
        },
        handleSubmit,
      }}
    />
  );
};

export default AssignCareerSite;
